import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getFieldVisionState } from '../store/selectors/getFieldVision';
import Button from '../components/Button';
import changeViewAction from '@gameday/app/lib/store/actions/views';
import useTracking from '@gameday/utils/hooks/useTracking';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import fieldVisionRequestAction from '../store/actions/FieldVisionRequestAction';
import MlbNativeWrapper from '@gameday/utils/MlbNativeWrapper';
import schedule from '@gameday/core/datasources/schedule';
import entitlements from '@gameday/core/datasources/entitlements';
import { useEntitlements } from '@gameday/utils/hooks/useEntitlements';

const datasources = {
    schedule,
    entitlements
};

initContainerData.register({
    datasources
});

const fetchData = () => {
    return fieldVisionRequestAction();
};

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const getEnableFieldVision = ({
    isFieldVisionSupported,
    freeGameOfTheDay,
    hasEntitlements,
    fieldVisionLiveFreeGameOnly,
    fieldVisionLoggedInOnly,
    isLoggedIn
}) => {
    // intentionally goes through checks here with this order for given business rules
    if (!isFieldVisionSupported) {
        return false;
    };

    if (hasEntitlements) {
        return true;
    };

    if (!fieldVisionLiveFreeGameOnly) {
        return true;
    };

    if (freeGameOfTheDay) {
        return true;
    };

    if (fieldVisionLoggedInOnly && !isLoggedIn) {
        return false;
    }

    return false;
};

const FieldVisionButtonDataContainer = (props) => {
    const { firstRunUser } = props;
    const {
        forcedFieldVisionOn,
        isLoggedIn,
        fieldVisionOn,
        isFieldVisionSupported,
        freeGameOfTheDay,
        fieldVisionLiveFreeGameOnly,
        fieldVisionLoggedInOnly
    } = useSelector(getFieldVisionState);
    const dispatch = useDispatch();
    const Tracking = useTracking();
    const hasEntitlements = useEntitlements();
    const showFieldVision = () => {
        dispatch(changeViewAction({
            fieldVisionOn: true
        }));
        // tracking fv
        MlbNativeWrapper.then((results) => {
            const { startTrace } = results;
            startTrace('gameday: fv launch');
        });
        Tracking.track.track_fieldvision_pageload();
    };

    const showGameday = () => {
        dispatch(changeViewAction({
            fieldVisionOn: false
        }));
        // tracking fv2 - gameday
        Tracking.track.track_pageload();
    };

    const showCameraMenu = () => {};
    const enableFieldVision = getEnableFieldVision({ isFieldVisionSupported, freeGameOfTheDay, hasEntitlements, fieldVisionLiveFreeGameOnly, isLoggedIn, fieldVisionLoggedInOnly });
    const showButton = (forcedFieldVisionOn || enableFieldVision);

    return (
        <>
            {showButton
                ? <Button
                    fieldVisionOn={fieldVisionOn}
                    isLoggedIn={isLoggedIn}
                    showFieldVision={ showFieldVision }
                    showGameday={ showGameday }
                    buttonClickHandler={ props?.buttonClickHandler }
                    showCameraMenu={ showCameraMenu }
                    buttonType={props?.buttonType}
                    firstRunUser={firstRunUser}
                    {...props} />
                : null}
        </>
    );
};

export default FieldVisionButtonDataContainer;
export { fetchData, routes };
